import logo from '../../../assets/images/Tempus-Text-Light-2.png';
import finairaLogo from '../../../assets/images/FinairaLogo.png';

export function BrandingPanel() {
  return (
    <div
      className="hidden lg:flex lg:w-[55%] relative overflow-hidden flex-col items-center justify-center p-16"
      style={{ background: 'linear-gradient(135deg, #444ab2 0%, #459fec 100%)' }}
    >
      <div
        className="absolute top-[-80px] left-[-80px] w-96 h-96 rounded-full opacity-20"
        style={{ background: 'radial-gradient(circle, #fff 0%, transparent 70%)' }}
      />
      <div
        className="absolute bottom-[-60px] right-[-60px] w-80 h-80 rounded-full opacity-10"
        style={{ background: 'radial-gradient(circle, #fff 0%, transparent 70%)' }}
      />
      <div className="relative z-10 flex flex-col items-center text-center max-w-md">
        <div className="mb-3 bg-white rounded-2xl px-8 py-5 shadow-2xl shadow-black/20">
          <img src={logo} alt="Tempus" className="h-auto w-90" />
          <div className="flex items-center justify-center gap-2 px-3 mt-2">
            <span className="whitespace-nowrap text-[10px] font-semibold uppercase tracking-widest text-slate-400 dark:text-slate-500">
              Powered by
            </span>
            <img src={finairaLogo} alt="Finaira" className="h-3 w-auto" />
          </div>
        </div>
        <h2 className="text-2xl font-semibold text-white mb-4 leading-tight whitespace-nowrap">
          Track your time, own your work.
        </h2>
        <p className="text-white/75 text-lg leading-relaxed">
          Effortlessly log hours, manage projects, and gain insights across your entire team.
        </p>
      </div>
    </div>
  );
}
